import React, { useState } from 'react';
import SEO from "../components/SEO";

const roomConfigs = {
  otSuite: {
    label: 'OT Suite Designs',
    icon: '🏥',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New OT Suite Construction',
        'Renovation of Existing OT',
        'OT Suite Expansion',
      ]},
      style: { label: 'Design Preference', choices: [
        'Standard Modular Layout',
        'Premium Hybrid OT Design',
        'Multi-OT Complex Layout',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Medical Gas Pipeline Planning',
      'Laminar Airflow Design',
    ],
  },
  icuLayout: {
    label: 'ICU Layout Designs',
    icon: '🛏️',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New ICU Construction',
        'ICU Renovation',
        'ICU Expansion',
      ]},
      style: { label: 'Bed Configuration', choices: [
        'Open Bay Layout',
        'Semi-Cubicle Layout',
        'Fully Isolated Cubicles',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Nurse Station Integration',
      'Medical Gas Manifold Planning',
    ],
  },
  patientWard: {
    label: 'Patient Ward Designs',
    icon: '🛌',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Ward Construction',
        'Ward Renovation',
        'Ward Expansion',
      ]},
      style: { label: 'Ward Type', choices: [
        'General Ward (Shared)',
        'Semi-Private Rooms',
        'Private Rooms / Suites',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Bed-Head Panel Design',
      'Furniture & Fit-Out Planning',
    ],
  },
  receptionLobby: {
    label: 'Reception Lobby Designs',
    icon: '🛋️',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Reception / Lobby',
        'Reception Renovation',
        'Lobby Expansion',
      ]},
      style: { label: 'Design Theme', choices: [
        'Minimal & Clinical',
        'Warm & Hospitality-Style',
        'Premium / Luxury Finish',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Signage & Wayfinding Design',
      'Waiting Area Furniture Planning',
    ],
  },
  diagnosticRoom: {
    label: 'Diagnostic Room Designs',
    icon: '🩻',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Diagnostic Room',
        'Renovation',
        'Multi-Room Diagnostic Wing',
      ]},
      style: { label: 'Room Type', choices: [
        'X-Ray / Imaging Room',
        'Ultrasound Room',
        'Multi-Purpose Diagnostic Room',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Radiation Shielding Planning',
      'Control Room Design',
    ],
  },
  pharmacy: {
    label: 'Pharmacy Designs',
    icon: '💊',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Pharmacy Setup',
        'Pharmacy Renovation',
        'Pharmacy Expansion',
      ]},
      style: { label: 'Pharmacy Type', choices: [
        'Retail Counter Pharmacy',
        'In-Patient Pharmacy',
        'Central Drug Store',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Storage & Shelving Design',
      'Cold Chain Storage Planning',
    ],
  },
  nursingStation: {
    label: 'Nursing Station Designs',
    icon: '🩺',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Nursing Station',
        'Renovation',
        'Multi-Station Layout',
      ]},
      style: { label: 'Station Type', choices: [
        'Central Nurse Station',
        'Satellite / Ward-Wise Stations',
        'Integrated Monitoring Station',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Central Monitoring Integration',
      'Storage & Documentation Counter',
    ],
  },
  isolationRoom: {
    label: 'Isolation Room Designs',
    icon: '🚪',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Isolation Room',
        'Renovation',
        'Multi-Room Isolation Ward',
      ]},
      style: { label: 'Pressure Type', choices: [
        'Negative Pressure Isolation',
        'Positive Pressure Isolation',
        'Standard Isolation (No Pressure Control)',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Anteroom Design',
      'HVAC & Air Handling Planning',
    ],
  },
  paediatricWard: {
    label: 'Paediatric Ward Designs',
    icon: '🧸',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Paediatric Ward',
        'Renovation',
        'Ward Expansion',
      ]},
      style: { label: 'Design Theme', choices: [
        'Playful / Child-Friendly Theme',
        'Neutral Clinical Theme',
        'Mixed (Play Area + Clinical)',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Play Area Design',
      'Parent Accommodation Planning',
    ],
  },
  oncologyUnit: {
    label: 'Oncology Unit Designs',
    icon: '🎗️',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Oncology Unit',
        'Renovation',
        'Unit Expansion',
      ]},
      style: { label: 'Unit Focus', choices: [
        'Chemotherapy Day Care',
        'Radiation Therapy Suite',
        'Combined Oncology Wing',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Radiation Shielding Planning',
      'Infusion Bay Layout',
    ],
  },
  maternitySuite: {
    label: 'Maternity Suite Designs',
    icon: '👶',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Maternity Suite',
        'Renovation',
        'Suite Expansion',
      ]},
      style: { label: 'Suite Type', choices: [
        'Labour & Delivery Room',
        'Post-Natal Recovery Suite',
        'Combined LDR + Nursery',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Nursery Integration Design',
      'Family Waiting Area Planning',
    ],
  },
  labPathology: {
    label: 'Lab & Pathology Designs',
    icon: '🔬',
    options: {
      scope: { label: 'Project Scope', choices: [
        'New Lab / Pathology Setup',
        'Renovation',
        'Lab Expansion',
      ]},
      style: { label: 'Lab Type', choices: [
        'Basic Pathology Lab',
        'Multi-Discipline Lab',
        'NABL-Accredited Reference Lab',
      ]},
    },
    addons: [
      '2D Layout & Concept Design',
      '3D Walkthrough / Rendering',
      'Biosafety Cabinet Planning',
      'Sample Storage Design',
    ],
  },
};

const cities = [
  'Hyderabad', 'Vijayawada', 'Visakhapatnam', 'Guntur', 'Tirupati',
  'Kurnool', 'Nellore', 'Rajahmundry', 'Warangal', 'Karimnagar', 'Nizamabad',
];

const WHATSAPP_NUMBER = '919993999840';

const STEPS = ['Service', 'Configure', 'Add-ons', 'Contact'];
const OTHER_STEPS = ['Service', 'Describe', 'Contact'];

export default function Calculator() {
  const [step, setStep] = useState(0);
  const [serviceKey, setServiceKey] = useState(null);
  const [selections, setSelections] = useState({});
  const [addons, setAddons] = useState([]);
  const [otherText, setOtherText] = useState('');
  const [city, setCity] = useState('Hyderabad');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [hospitalName, setHospitalName] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  React.useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const isOther = serviceKey === 'other';
  const config = serviceKey && !isOther ? roomConfigs[serviceKey] : null;
  const currentSteps = isOther ? OTHER_STEPS : STEPS;

  const selectService = (key) => {
    setServiceKey(key);
    setSelections({});
    setAddons([]);
    setOtherText('');
    setStep(1);
  };

  const canProceedConfigure = config && Object.keys(selections).length === Object.keys(config.options).length;
  const canProceedOther = otherText.trim().length > 0;

  const goNext = () => setStep((s) => Math.min(s + 1, currentSteps.length - 1));
  const goBack = () => setStep((s) => Math.max(s - 1, 0));

  const buildWhatsAppMessage = () => {
    const lines = [];

    if (isOther) {
      lines.push(`Hi, I'd like a quote for a custom hospital design requirement.`);
      lines.push('');
      lines.push(`Location: ${city}`);
      lines.push('');
      lines.push(`Requirement:`);
      lines.push(otherText);
    } else {
      lines.push(`Hi, I'd like a quote for *${config.label}*.`);
      lines.push('');
      lines.push(`Location: ${city}`);
      Object.entries(selections).forEach(([key, idx]) => {
        lines.push(`${config.options[key].label}: ${config.options[key].choices[idx]}`);
      });
      if (addons.length > 0) {
        lines.push('');
        lines.push('Add-ons:');
        addons.forEach((i) => lines.push(`- ${config.addons[i]}`));
      }
    }

    lines.push('');
    lines.push(`Name: ${name}`);
    lines.push(`Phone: ${phone}`);
    if (hospitalName) lines.push(`Facility: ${hospitalName}`);
    return lines.join('\n');
  };

  const handleSubmit = () => {
    if (!name || !phone) return;
    const message = buildWhatsAppMessage();
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    setSubmitted(true);
  };

  const startOver = () => {
    setStep(0);
    setServiceKey(null);
    setSelections({});
    setAddons([]);
    setOtherText('');
    setCity('Hyderabad');
    setName('');
    setPhone('');
    setHospitalName('');
    setSubmitted(false);
  };

  const contactStepIndex = currentSteps.length - 1;

  return (
     <>
    <SEO/>
    <div className="calc-page">
      <style>{`
        .calc-page {
          padding-top: 68px;
          font-family: 'Inter', 'Montserrat', sans-serif;
        }
        @media (max-width: 900px) {
          .calc-page { padding-top: 60px; }
        }
        @media (max-width: 480px) {
          .calc-page { padding-top: 0px; }
        }
      `}</style>

      {/* Page Hero */}
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-label">🏥 Project Estimator</div>
          <h1 className="page-hero-title">Hospital Infrastructure<br/>Project Enquiry</h1>
          <p className="page-hero-sub">Tell us what you're building and our project team will coordinate with you directly on WhatsApp.</p>
        </div>
      </div>

      <section className="section-alt">
        <div className="container" style={{ maxWidth: 720 }}>

          {/* Progress bar */}
          {!submitted && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: isMobile ? 24 : 32,
              overflowX: isMobile ? 'auto' : 'visible',
              paddingBottom: isMobile ? 4 : 0,
            }}>
              {currentSteps.map((label, i) => (
                <React.Fragment key={label}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                    <div style={{
                      width: 28, height: 28, borderRadius: '50%',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 12, fontWeight: 700, flexShrink: 0,
                      background: i <= step ? '#343F86' : '#fff',
                      color: i <= step ? '#fff' : '#8A8F9C',
                      border: '1.5px solid', borderColor: i <= step ? '#343F86' : '#E1E3EE',
                    }}>{i + 1}</div>
                    <span style={{
                      fontSize: isMobile ? 12 : 13,
                      fontWeight: i === step ? 700 : 500,
                      color: i <= step ? '#343F86' : '#8A8F9C',
                      whiteSpace: 'nowrap',
                    }}>{label}</span>
                  </div>
                  {i < currentSteps.length - 1 && (
                    <div style={{
                      flex: isMobile ? '0 0 24px' : 1,
                      height: 1,
                      background: i < step ? '#343F86' : '#E1E3EE',
                      margin: isMobile ? '0 8px' : '0 14px',
                    }} />
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          {submitted ? (
            /* Final confirmation screen */
            <div style={{
              background: '#fff', border: '1px solid #E1E3EE',
              padding: isMobile ? '40px 20px' : '56px 32px',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: 44, marginBottom: 16 }}>✓</div>
              <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontWeight: 700, fontSize: isMobile ? 22 : 26, marginBottom: 12, color: '#343F86' }}>Request Sent</h2>
              <p style={{ fontSize: isMobile ? 13 : 14, color: '#5B6072', lineHeight: 1.6, marginBottom: 28 }}>
                Thanks, {name}. We've opened WhatsApp with your {isOther ? 'custom' : config.label} requirements — just hit send, and our project team will coordinate with you directly.
              </p>
              <button className="btn-primary" onClick={startOver}>Start a New Enquiry</button>
            </div>
          ) : (
            <div style={{ background: '#fff', border: '1px solid #E1E3EE', padding: isMobile ? '22px 18px' : 36 }}>

              {/* Step 0: Select service */}
              {step === 0 && (
                <>
                  <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontWeight: 700, fontSize: isMobile ? 22 : 26, marginBottom: 8, color: '#343F86' }}>Which service do you need?</h2>
                  <p style={{ fontSize: 13, color: '#5B6072', marginBottom: isMobile ? 18 : 24 }}>Select the design project you're planning.</p>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(170px, 1fr))',
                    gap: isMobile ? 8 : 10,
                  }}>
                    {Object.entries(roomConfigs).map(([key, cfg]) => (
                      <button key={key}
                        onClick={() => selectService(key)}
                        style={{
                          display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start',
                          padding: isMobile ? '14px 12px' : '18px 16px', border: '1.5px solid #E1E3EE', background: '#fff',
                          cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s',
                          fontFamily: "'Inter', 'Montserrat', sans-serif",
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#343F86'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#E1E3EE'; }}
                      >
                        <span style={{ fontSize: isMobile ? 20 : 22 }}>{cfg.icon}</span>
                        <span style={{ fontSize: isMobile ? 12.5 : 13.5, fontWeight: 600, color: '#343F86', lineHeight: 1.3 }}>{cfg.label}</span>
                      </button>
                    ))}
                    {/* Other option */}
                    <button
                      onClick={() => selectService('other')}
                      style={{
                        display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start',
                        padding: isMobile ? '14px 12px' : '18px 16px', border: '1.5px dashed #8A8F9C', background: '#F6F7FC',
                        cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s',
                        fontFamily: "'Inter', 'Montserrat', sans-serif",
                      }}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#343F86'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#8A8F9C'; }}
                    >
                      <span style={{ fontSize: isMobile ? 20 : 22 }}>✏️</span>
                      <span style={{ fontSize: isMobile ? 12.5 : 13.5, fontWeight: 600, color: '#343F86', lineHeight: 1.3 }}>Other (Tell Us What You Need)</span>
                    </button>
                  </div>
                </>
              )}

              {/* Step 1 (non-other): Configure */}
              {step === 1 && !isOther && config && (
                <>
                  <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontWeight: 700, fontSize: isMobile ? 20 : 26, marginBottom: isMobile ? 20 : 28, color: '#343F86' }}>Configure Your {config.label}</h2>

                  <div className="form-group">
                    <label className="form-label">Project Location</label>
                    <select className="form-select" value={city} onChange={e => setCity(e.target.value)}>
                      {cities.map(c => <option key={c}>{c}</option>)}
                    </select>
                  </div>

                  {Object.entries(config.options).map(([key, opt]) => (
                    <div key={key} className="form-group">
                      <label className="form-label">{opt.label}</label>
                      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)', gap: 8 }}>
                        {opt.choices.map((choice, i) => (
                          <button key={i}
                            onClick={() => setSelections(s => ({ ...s, [key]: i }))}
                            style={{
                              padding: '10px 14px', border: '1.5px solid',
                              borderColor: selections[key] === i ? '#343F86' : '#E1E3EE',
                              background: selections[key] === i ? '#343F86' : '#fff',
                              color: selections[key] === i ? '#fff' : '#3A4060',
                              fontSize: 13, cursor: 'pointer', textAlign: 'left',
                              transition: 'all 0.2s', fontFamily: "'Inter', 'Montserrat', sans-serif",
                            }}
                          >{choice}</button>
                        ))}
                      </div>
                    </div>
                  ))}
                </>
              )}

              {/* Step 1 (other): Describe requirement */}
              {step === 1 && isOther && (
                <>
                  <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontWeight: 700, fontSize: isMobile ? 20 : 26, marginBottom: 8, color: '#343F86' }}>Tell Us What You Need</h2>
                  <p style={{ fontSize: 13, color: '#5B6072', marginBottom: isMobile ? 18 : 24 }}>Describe the space, service, or design you're looking for — as much detail as you can share.</p>

                  <div className="form-group">
                    <label className="form-label">Project Location</label>
                    <select className="form-select" value={city} onChange={e => setCity(e.target.value)}>
                      {cities.map(c => <option key={c}>{c}</option>)}
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Your Requirement</label>
                    <textarea
                      className="form-input"
                      placeholder="e.g. We need a design for a 20-bed rehabilitation ward with attached physiotherapy area..."
                      value={otherText}
                      onChange={e => setOtherText(e.target.value)}
                      rows={isMobile ? 5 : 6}
                      style={{ resize: 'vertical', fontFamily: "'Inter', 'Montserrat', sans-serif", lineHeight: 1.6 }}
                    />
                  </div>
                </>
              )}

              {/* Step 2 (non-other): Add-ons */}
              {step === 2 && !isOther && config && (
                <>
                  <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontWeight: 700, fontSize: isMobile ? 20 : 26, marginBottom: 8, color: '#343F86' }}>Add-ons</h2>
                  <p style={{ fontSize: 13, color: '#5B6072', marginBottom: isMobile ? 18 : 24 }}>Optional — select anything else you'd like included.</p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {config.addons.map((addon, i) => (
                      <label key={i} style={{
                        display: 'flex', alignItems: 'center', gap: 12,
                        padding: '12px 16px', border: '1.5px solid',
                        borderColor: addons.includes(i) ? '#343F86' : '#E1E3EE',
                        background: addons.includes(i) ? '#F6F7FC' : '#fff',
                        cursor: 'pointer', transition: 'all 0.2s',
                      }}>
                        <input type="checkbox"
                          checked={addons.includes(i)}
                          onChange={e => setAddons(a => e.target.checked ? [...a, i] : a.filter(x => x !== i))}
                          style={{ accentColor: '#343F86', width: 16, height: 16, flexShrink: 0 }}
                        />
                        <span style={{ fontSize: isMobile ? 13 : 14, color: '#343F86' }}>{addon}</span>
                      </label>
                    ))}
                  </div>
                </>
              )}

              {/* Contact step (last step for both flows) */}
              {step === contactStepIndex && (
                <>
                  <h2 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontWeight: 700, fontSize: isMobile ? 20 : 26, marginBottom: 8, color: '#343F86' }}>Your Details</h2>
                  <p style={{ fontSize: 13, color: '#5B6072', marginBottom: isMobile ? 18 : 24 }}>We'll open WhatsApp with your requirements pre-filled, ready to send.</p>
                  <div className="form-group" style={{ marginBottom: 16 }}>
                    <label className="form-label">Your Name</label>
                    <input className="form-input" placeholder="Full name" value={name} onChange={e => setName(e.target.value)} />
                  </div>
                  <div className="form-group" style={{ marginBottom: 16 }}>
                    <label className="form-label">Phone Number</label>
                    <input className="form-input" placeholder="Phone number" value={phone} onChange={e => setPhone(e.target.value)} />
                  </div>
                  <div className="form-group" style={{ marginBottom: 8 }}>
                    <label className="form-label">Hospital / Facility Name (Optional)</label>
                    <input className="form-input" placeholder="Facility name" value={hospitalName} onChange={e => setHospitalName(e.target.value)} />
                  </div>
                </>
              )}

              {/* Nav buttons */}
              {step > 0 && (
                <div style={{
                  display: 'flex', justifyContent: 'space-between',
                  marginTop: isMobile ? 24 : 32, paddingTop: isMobile ? 18 : 24,
                  borderTop: '1px solid #ECEEF6',
                }}>
                  <button
                    onClick={goBack}
                    style={{ padding: isMobile ? '10px 16px' : '10px 20px', border: '1.5px solid #E1E3EE', background: '#fff', color: '#3A4060', fontSize: 13, cursor: 'pointer', fontFamily: "'Inter', 'Montserrat', sans-serif" }}
                  >Back</button>

                  {step < contactStepIndex ? (
                    <button
                      onClick={goNext}
                      disabled={
                        (step === 1 && !isOther && !canProceedConfigure) ||
                        (step === 1 && isOther && !canProceedOther)
                      }
                      className="btn-primary"
                      style={{
                        opacity: ((step === 1 && !isOther && !canProceedConfigure) || (step === 1 && isOther && !canProceedOther)) ? 0.4 : 1,
                        cursor: ((step === 1 && !isOther && !canProceedConfigure) || (step === 1 && isOther && !canProceedOther)) ? 'not-allowed' : 'pointer',
                      }}
                    >Continue</button>
                  ) : (
                    <button
                      onClick={handleSubmit}
                      disabled={!name || !phone}
                      className="btn-primary"
                      style={{ opacity: (!name || !phone) ? 0.4 : 1, cursor: (!name || !phone) ? 'not-allowed' : 'pointer' }}
                    >Send via WhatsApp</button>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Inclusions */}
          {!submitted && (
            <div style={{ background: '#fff', border: '1px solid #E1E3EE', padding: isMobile ? '22px 18px' : '32px', marginTop: isMobile ? 24 : 32 }}>
              <h3 style={{ fontFamily: "'Montserrat', 'Inter', sans-serif", fontWeight: 700, fontSize: isMobile ? 18 : 20, marginBottom: isMobile ? 18 : 24, color: '#343F86' }}>What's Included</h3>
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
                gap: isMobile ? 16 : 20,
              }}>
                {[
                  { icon: '📐', title: '3D Design & Layout', desc: 'Detailed 3D rendering of the clinical space before execution' },
                  { icon: '🏭', title: 'Factory-Made Components', desc: 'Precision-engineered modular panels, not on-site fabrication' },
                  { icon: '📋', title: 'NABH Documentation', desc: 'Compliance-ready documentation for accreditation' },
                  { icon: '🔧', title: 'Installation', desc: 'Professional installation by certified biomedical technicians' },
                  { icon: '🛡️', title: '10-Year Warranty', desc: 'Comprehensive warranty on fixtures, panels, and systems' },
                  { icon: '📞', title: 'After-Sales Support', desc: 'Dedicated support team for the lifetime of your facility' },
                ].map((item, i) => (
                  <div key={i} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                    <span style={{ fontSize: 24 }}>{item.icon}</span>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#343F86', marginBottom: 4 }}>{item.title}</div>
                      <div style={{ fontSize: 13, color: '#5B6072', lineHeight: 1.5 }}>{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
    </>
  );
}